import React from 'react';
import { Icon } from '@iconify/react';

function PasswordSection({ onOpenModal }) {
  return (
    <div id="security" className="mb-4 pb-3">
      <h4 className="d-flex align-items-center mb-2 mt-3">
        <Icon className="iconify fs-24px me-2 text-body text-opacity-75 my-n1" icon="solar:lock-password-bold-duotone" />
        Security
      </h4>
      <p>パスワードやログインに関する設定です。</p>
      <div className="card">
        <div className="list-group list-group-flush fw-bold">
          <div className="list-group-item d-flex align-items-center">
            <div className="flex-fill">
              <div>Password</div>
              <div className="text-body text-opacity-60">••••••••</div>
            </div>
            <div>
              <a href="#modalEdit" data-bs-toggle="modal" onClick={() => onOpenModal('password')} className="btn btn-secondary w-100px">Update</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PasswordSection;